import Drawer from "@material-ui/core/Drawer";
import React from "react";
import { CcIconClose } from "../../icons";
import { CcIconButton } from "../mui";
import { cx } from "../utils";

const SIZE_CLASS = {
  sm: "cc-drawer--sm",
  md: "cc-drawer--md",
  lg: "cc-drawer--lg",
  xl: "cc-drawer--xl",
  full: "cc-drawer--full",
};

/**
 * CcDrawer — Carecentre Zen editorial side panel (replaces GlassDrawer on migrated flows).
 */
const CcDrawer = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = "md",
  anchor = "right",
  showCloseButton = true,
  noPadding = false,
  headerActions,
  className,
  contentClassName,
  ...props
}) => (
  <Drawer
    open={Boolean(open)}
    anchor={anchor}
    onClose={onClose}
    className={cx("cc-drawer-root", className)}
    classes={{
      paper: cx("cc-drawer", SIZE_CLASS[size] || SIZE_CLASS.md),
    }}
    ModalProps={{
      BackdropProps: { className: "cc-drawer__backdrop" },
    }}
    {...props}
  >
    {(title || showCloseButton) && (
      <header className="cc-drawer__header">
        <div className="cc-drawer__header-text">
          {title ? <h2 className="cc-drawer__title">{title}</h2> : null}
          {subtitle ? <p className="cc-drawer__subtitle">{subtitle}</p> : null}
        </div>
        {headerActions}
        {showCloseButton && onClose ? (
          <CcIconButton
            label="Close"
            variant="secondary"
            size="sm"
            onClick={onClose}
          >
            <CcIconClose size={18} />
          </CcIconButton>
        ) : null}
      </header>
    )}

    <div
      className={cx(
        "cc-drawer__body",
        noPadding && "cc-drawer__body--flush",
        contentClassName,
      )}
    >
      {children}
    </div>

    {footer ? <footer className="cc-drawer__footer">{footer}</footer> : null}
  </Drawer>
);

export default CcDrawer;
